import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import LoadAnim from "../components/LoadAnim";
import Myprojects from "../general/Myprojects";

export default function PortfolioView(indexOf) {
  const titleRef = useRef(null);
  const videoRef = useRef(null);
  const paragraphRef = useRef(null);
  const [videoWidth, setVideoWidth] = useState("auto");
  console.log("indexOf:", indexOf);
  useEffect(() => {
    // GSAP scroll animation
    if (titleRef.current) {
      gsap.fromTo(
        titleRef.current,
        { y: 0, opacity: 1 },
        {
          y: 100,
          opacity: 0,
          scrollTrigger: {
            trigger: titleRef.current,
            start: "top top",
            end: "bottom top",
            scrub: 1,
            toggleActions: "play none none reverse",
          },
        }
      );
    }

    // Function to update paragraph width based on video width
    const updateParagraphWidth = () => {
      if (videoRef.current && paragraphRef.current) {
        setVideoWidth(`${videoRef.current.clientWidth}px`);
      }
    };

    // Call once after mount and when the video loads
    updateParagraphWidth();

    // Add event listeners for window resize
    window.addEventListener("resize", updateParagraphWidth);

    return () => {
      window.removeEventListener("resize", updateParagraphWidth);
    };
  }, []);

  return (
    <div>
      <div
        ref={titleRef}
        className="title px-[70px] relative pb-[0] pt-[100px] overflow-hidden flex flex-col items-center"
      >
        <LoadAnim>
          <h2 className="smooth font-florian text-white text-[90px] font-light leading-[100%] tracking-[5px]">
            SIMO DJUKANOVIC
          </h2>
        </LoadAnim>
      </div>
      <div className="px-[70px] relative pb-[100px] pt-[50px] overflow-hidden flex flex-col items-center">
        <LoadAnim>
          <video
            ref={videoRef}
            className="h-full w-full rounded-lg max-h-[80vh] min-w-[50vw]"
            controls
            poster={Myprojects[indexOf.indexOf].img}
            onLoadedMetadata={() =>
              setVideoWidth(`${videoRef.current.clientWidth}px`)
            }
          >
            <source src={Myprojects[indexOf.indexOf].video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </LoadAnim>
        <div
          className="flex ref={paragraphRef}  mt-[40px] gap-[100px] item-start"
          style={{ width: videoWidth }}
          ref={paragraphRef}
        >
          <div>
            <LoadAnim className="">
              <h2 className="text-white text-center text-[16px] whitespace-nowrap w-full">
                {Myprojects[indexOf.indexOf].name}
              </h2>
            </LoadAnim>
          </div>
          <LoadAnim>
            <p className="text-white text-left text-[16px]">
              {Myprojects[indexOf.indexOf].desc}
            </p>
          </LoadAnim>
        </div>
      </div>
    </div>
  );
}
